import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import VisibilityIcon from '@mui/icons-material/Visibility';
import Dialog from '@mui/material/Dialog';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { fetchData, deleteData, activateData } from '../../../apiService';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import InfoIcon from '@mui/icons-material/Info';
import SearchIcon from '@mui/icons-material/Search';
import Button from '@mui/material/Button';
import AddIcon from '@mui/icons-material/Add';
import { Tooltip } from '@mui/material';
import CancelIcon from '@mui/icons-material/Cancel';

function ReturnIndex() {
    const [data, setData] = useState([]);
    const [deleteItemId, setDeleteItemId] = useState(null);
    const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
    const [acceptDialogOpen, setAcceptDialogOpen] = useState(false);
    const [rejectDialogOpen, setRejectDialogOpen] = useState(false);
    const [currentItem, setCurrentItem] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const { isAuthenticated, companyId, userId, logout, token } = useAuth();

    useEffect(() => {
        if (isAuthenticated && tokenIsExpired(token)) {
            logout();
            return;
        }
        fetchtableData();
    }, [isAuthenticated, companyId, token, userId, logout]);

    useEffect(() => {
        fetchtableData();
    }, []);

    const fetchtableData = async () => {
        fetchData('EngineerStockTransferApi', `/${companyId}`, token)
            .then((response) => {
                if (response.responseCode === '1111') {
                    console.log(response);
                    setData(response.response_data);
                }
            })
            .catch((error) => {
                console.error('Error fetching Expense Details:', error);
            });
    };

    const handleDelete = async () => {
        deleteData('EngineerStockTransferApi', `${deleteItemId}`, token)
            .then((response) => {
                fetchtableData();
                setDeleteItemId(null);
                setConfirmDialogOpen(false);
            })
            .catch((error) => {
                console.error('Error deleting record:', error);
            });
    };

    const handleActivate = (itemId) => {
        activateData('EngineerStockTransferApi', `${itemId}`, token)
            .then((response) => {
                fetchtableData();
            })
            .catch((error) => {
                console.error('Error activating record:', error);
            });
    };

    const openConfirmDialog = (itemId) => {
        setDeleteItemId(itemId);
        setConfirmDialogOpen(true);
    };

    const closeConfirmDialog = () => {
        setDeleteItemId(null);
        setConfirmDialogOpen(false);
    };

    const openAcceptDialog = (item) => {
        setCurrentItem(item);
        setAcceptDialogOpen(true);
    };

    const closeAcceptDialog = () => {
        setCurrentItem(null);
        setAcceptDialogOpen(false);
    };

    const openRejectDialog = (item) => {
        setCurrentItem(item);
        setRejectDialogOpen(true);
    };

    const closeRejectDialog = () => {
        setCurrentItem(null);
        setRejectDialogOpen(false);
    };

    const handleAccept = async () => {
        setIsLoading(true);
        const Claims = {
            ID: currentItem.id,
            CompanyID: companyId,
            Quantity: currentItem.quantity,
            SparePartsID: currentItem.sparePartsID,
            StaffID: currentItem.staffID,
            IsAcceptedReturn: true,
            UpdatedBy: userId
        };

        try {
            //const response = await axios.put(`https://localhost:7291/api/EngineerStockTransferApi/${currentItem.id}`, Claims, {
            const response = await axios.put(`https://pp-api.off-ease.com/api/EngineerStockTransferApi/${currentItem.id}`, Claims, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });
            console.log('Claim Approve successed:', response.data);
            fetchtableData();
        } catch (error) {
            console.error('Claim Approved error:', error);
        } finally {
            setIsLoading(false);
            closeAcceptDialog();
        }
    };

    const handleReject = async () => {
        const Claims = {
            ID: currentItem.id,
            CompanyID: companyId,
            Quantity: currentItem.quantity,
            SparePartsID: currentItem.sparePartsID,
            StaffID: currentItem.staffID,
            IsAcceptedReturn: false,
            UpdatedBy: userId
        };

        try {
            // const response = await axios.put(`https://localhost:7291/api/EngineerStockTransferApi/${currentItem.id}`, Claims, {
            const response = await axios.put(`https://pp-api.off-ease.com/api/EngineerStockTransferApi/${currentItem.id}`, Claims, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });
            console.log('Claim Rejected successed:');
            fetchtableData();
        } catch (error) {
            console.error('Claim Rejected error:', error);
        } finally {
            setIsLoading(false);
            closeRejectDialog();
        }
    };

    const [searchQuery, setSearchQuery] = useState('');
    const [showSearchInput, setShowSearchInput] = useState(false);
    const handleSearch = (event) => {
        setSearchQuery(event.target.value);
    };

    const toggleSearchInput = () => {
        setShowSearchInput(!showSearchInput);
    };

    const filteredData = data.filter((item) =>
        Object.values(item).some((value) =>
            String(value).toLowerCase().includes(searchQuery.toLowerCase())
        )
    );

    return (
        <div className="w-full max-w-sm container mt-6 mx-auto">
            <div className='w-full mb-2 flex'>
                <h6 className='productHead flex-grow linkcolor' style={{ color: 'black', fontFamily: 'Georgia, serif', fontWeight: 'bolder' }}>SPARE PARTS RETURN</h6>
                <div style={{ marginBottom: '10px', display: 'flex', alignItems: 'center' }}>
                    <SearchIcon onClick={toggleSearchInput} style={{ cursor: 'pointer' }} />
                    {showSearchInput && (
                        <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                            type="text"
                            placeholder="Search..."
                            value={searchQuery}
                            onChange={handleSearch}
                            style={{ marginLeft: '10px', width: '200px' }}
                        />
                    )}
                </div>
            </div>

            <div className='w-full mb-5 flex' style={{ maxHeight: '490px', overflowY: 'auto' }}>
                <TableContainer component={Paper}>
                    <Table stickyHeader>
                        <TableHead sx={{ backgroundColor: '#090040' }}>
                            <TableRow>
                                <TableCell sx={{ backgroundColor: '#090040', borderRight: '1px solid #ccc', borderBottom: '1px solid #ddd', fontWeight: 'bolder', fontSize: '10px', padding: '4px', textAlign: 'center', color: 'white', textTransform: 'uppercase' }}>Sl.no</TableCell>
                                <TableCell sx={{ backgroundColor: '#090040', borderRight: '1px solid #ccc', borderBottom: '1px solid #ddd', fontWeight: 'bolder', fontSize: '10px', padding: '4px', textAlign: 'center', color: 'white', textTransform: 'uppercase' }}>ReturnDate</TableCell>
                                <TableCell sx={{ backgroundColor: '#090040', borderRight: '1px solid #ccc', borderBottom: '1px solid #ddd', fontWeight: 'bolder', fontSize: '10px', padding: '4px', textAlign: 'center', color: 'white', textTransform: 'uppercase' }}>Spare</TableCell>
                                <TableCell sx={{ backgroundColor: '#090040', borderRight: '1px solid #ccc', borderBottom: '1px solid #ddd', fontWeight: 'bolder', fontSize: '10px', padding: '4px', textAlign: 'center', color: 'white', textTransform: 'uppercase' }}>Return QTY</TableCell>
                                <TableCell sx={{ backgroundColor: '#090040', borderRight: '1px solid #ccc', borderBottom: '1px solid #ddd', fontWeight: 'bolder', fontSize: '10px', padding: '4px', textAlign: 'center', color: 'white', textTransform: 'uppercase' }}>Return By</TableCell>
                                <TableCell sx={{ backgroundColor: '#090040', borderRight: '1px solid #ccc', borderBottom: '1px solid #ddd', fontWeight: 'bolder', fontSize: '10px', padding: '4px', textAlign: 'center', color: 'white', textTransform: 'uppercase' }}>Actions</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody style={{ backgroundColor: '#D5F5E3' }}>
                            {filteredData.map((item, index) => (
                                <TableRow key={item.id}>
                                    <TableCell sx={{ fontSize: '13px', padding: '5px', fontWeight: 'bolder' }}>{index + 1}</TableCell>
                                    <TableCell sx={{ fontSize: '13px', padding: '5px', fontWeight: 'bolder' }}>
                                        {item.date && new Date(item.date).toLocaleDateString('en-GB')}</TableCell>
                                    <TableCell sx={{ fontSize: '13px', padding: '5px', fontWeight: 'bolder' }}>{item.spare}</TableCell>
                                    <TableCell sx={{ fontSize: '13px', padding: '5px', fontWeight: 'bolder',textAlign:'center' }}>{item.quantity}</TableCell>
                                    <TableCell sx={{ fontSize: '13px', padding: '5px', fontWeight: 'bolder' }}>{item.staffName}</TableCell>
                                    <TableCell sx={{ fontSize: '13px', padding: '5px' }}>
                                        <Tooltip title="Accept">
                                            <IconButton style={{ color: 'green' }} onClick={() => openAcceptDialog(item)}>
                                                <CheckCircleIcon />
                                            </IconButton>
                                        </Tooltip>
                                        <Tooltip title="Reject">
                                            <IconButton style={{ color: 'red' }} onClick={() => openRejectDialog(item)}>
                                                <CancelIcon />
                                            </IconButton>
                                        </Tooltip>
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </div>
            <Dialog
                open={confirmDialogOpen}
                onClose={closeConfirmDialog}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">{"Delete Record?"}</DialogTitle>
                <DialogContent>
                    {currentItem && <DialogContentText>{currentItem.spare}</DialogContentText>}
                    <DialogContentText id="alert-dialog-description">
                        Are you sure you want to delete this record?
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={closeConfirmDialog} color="secondary">
                        Cancel
                    </Button>
                    <Button onClick={handleDelete} color="primary" autoFocus>
                        Confirm
                    </Button>
                </DialogActions>
            </Dialog>

            <Dialog
                open={acceptDialogOpen}
                onClose={closeAcceptDialog}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">{"Accept Return?"}</DialogTitle>
                <DialogContent>
                    {currentItem && <DialogContentText style={{ color: 'darkorange' }}>{`Spare: ${currentItem.spare}`}</DialogContentText>}
                    <DialogContentText id="alert-dialog-description">
                        Are you sure you want to accept this return?
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={closeAcceptDialog} color="secondary">
                        Cancel
                    </Button>
                    <Button onClick={handleAccept} color="primary" autoFocus>
                        Accept
                    </Button>
                </DialogActions>
            </Dialog>

            <Dialog
                open={rejectDialogOpen}
                onClose={closeRejectDialog}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">{"Reject Return?"}</DialogTitle>
                <DialogContent>
                    {currentItem && <DialogContentText style={{ color: 'brown' }}>{`Spare: ${currentItem.spare}`}</DialogContentText>}
                    <DialogContentText id="alert-dialog-description">
                        Are you sure you want to reject this return?
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={closeRejectDialog} color="secondary">
                        Cancel
                    </Button>
                    <Button onClick={handleReject} color="primary" autoFocus>
                        Reject
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
}

export default ReturnIndex;
